<template>
  <div class="unresolved-payment-container" :class="[{
    'unresolved-payment-container_open': isPossibleOptionsOpen
  }]" :style="{
    // 'z-index': zIndex
  }">
    <transition v-if="Array.isArray(payment.possible) && payment.possible.length" name="slide">
      <vx-card class="unresolved-payment-possible-options-card" v-if="isPossibleOptionsOpen">
        <div class="vx-row">
          <div class="vx-col w-full">

            <div class="possible-options-table-wrapper">
              <table class="possible-options-table">
                <caption class="possible-options-table__caption">
                  Совпадает по ФИО собственника
                </caption>

                <thead>
                <tr class="possible-options-table__row possible-options-table__row_thead">
                  <th class="possible-options-table__cell possible-options-table__cell_th">ФИО собственника</th>
                  <th class="possible-options-table__cell possible-options-table__cell_th">Собственность</th>
                  <th class="possible-options-table__cell possible-options-table__cell_th">Начислено</th>
                  <th class="possible-options-table__cell possible-options-table__cell_th" style="width: 240px"
                      v-if="false" />
                </tr>
                </thead>

                <tbody>
                <template v-for="(user, userIndex) in payment.possible">
                  <template v-for="(apartment, apartmentsIndex) in user.apartments">
                    <tr class="possible-options-table__row possible-option" :key="`${userIndex}-${apartmentsIndex}`">
                      <td class="possible-options-table__cell" :rowspan="user.apartments.length"
                          v-if="apartmentsIndex===0"
                          :class="[{
                          'possible-options-table__cell_hover': hoverIndexes.rowIndex.userIndex === userIndex,
                          'possible-options-table__cell_active': user.apartments.findIndex(apart => apart.account_number === resolveData.accountNumber) !== -1
                          }]"
                      >
                        <div class="possible-option__user-info">
                          <h5>{{ user.name }}</h5>
                          <p>ИНН {{ user.inn }}</p>
                        </div>

                      </td>
                      <td class="possible-options-table__cell possible-options-table__cell_pointer" :class="[{
                      'possible-options-table__cell_no-border-left': apartmentsIndex !== 0,
                      'possible-options-table__cell_no-border': apartmentsIndex !== 2 && apartmentsIndex !== user.apartments.length-1,
                      'possible-options-table__cell_no-border-top': apartmentsIndex === 2 && user.apartments.length !== 1,
                      'possible-options-table__cell_hover': hoverIndexes.rowIndex.userIndex === userIndex && hoverIndexes.rowIndex.apartmentsIndex === apartmentsIndex,
                      'possible-options-table__cell_active': resolveData.accountNumber === apartment.account_number
                      }]"
                          @mouseenter="hoverIndexes.rowIndex = {userIndex: userIndex, apartmentsIndex: apartmentsIndex}"
                          @mouseleave="hoverIndexes.rowIndex = {userId: null, accountNumber: null}"
                          @click="selectPossibleOption(apartment)"
                      >
                        <div class="possible-option__apartment-info">
                          <feather-icon icon="HomeIcon" class="possible-option__apartment-info-icon" />
                          <span class="possible-option__apartment-info-address">г. Санкт-Петербург, Южное шоссе, д. 55 к. 3, кв. {{
                              apartmentsIndex + 100000
                            }}</span>
                        </div>

                      </td>
                      <td class="possible-options-table__cell possible-options-table__cell_pointer" :class="[{
                       'possible-options-table__cell_no-border-left': apartmentsIndex !== 0,
                      'possible-options-table__cell_no-border': apartmentsIndex !== 2 && apartmentsIndex !== user.apartments.length-1,
                      'possible-options-table__cell_no-border-top': apartmentsIndex === 2 && user.apartments.length !== 1,
                      'possible-options-table__cell_hover': hoverIndexes.rowIndex.userIndex === userIndex && hoverIndexes.rowIndex.apartmentsIndex === apartmentsIndex,
                      'possible-options-table__cell_active': resolveData.accountNumber === apartment.account_number
                    }]"
                          @mouseenter="hoverIndexes.rowIndex = {userIndex: userIndex, apartmentsIndex: apartmentsIndex}"
                          @mouseleave="hoverIndexes.rowIndex = {userId: null, accountNumber: null}"
                          @click="selectPossibleOption(apartment)"
                      >
                        <div class="possible-option__charge-info">
                          <p>Январь: 1231,12р</p>
                          <p>Декабрь: 2330р</p>
                          <p>Ноябрь: 1234р</p>
                        </div>

                      </td>
                      <td class="possible-options-table__cell" :class="[{
                       'possible-options-table__cell_no-border-left': apartmentsIndex !== 0,
                      'possible-options-table__cell_no-border': apartmentsIndex !== 2 && apartmentsIndex !== user.apartments.length-1,
                      'possible-options-table__cell_no-border-top': apartmentsIndex === 2 && user.apartments.length !== 1,
                    }]" v-if="false">
                        <div class="flex flex-wrap items-center possible-option__resolve">
                          <div class="unresolved-payment__resolve-month" :class="[{
                            'unresolved-payment__resolve-month_error': resolveData.errors.month && resolveData.month === null
                          }]">
                            <label class="vs-select--label mt-1">Месяц назначения</label>
                            <datepicker class="w-full"
                                        format="MMMM yyyy"
                                        minimum-view="month"
                                        maximum-view="year"
                                        v-model="resolveData.month"
                            />
                          </div>

                          <div class="unresolved-payment__resolve-buttons">
                            <vs-button icon-pack="feather" icon="icon-check" color="success" @click="resolveByData" />
                            <vs-button icon-pack="feather" icon="icon-x1" color="danger" @click="resetResolveData" />
                          </div>
                        </div>

                      </td>
                    </tr>
                  </template>
                </template>

                </tbody>
              </table>
            </div>

          </div>
        </div>
      </vx-card>
    </transition>
    <vx-card class="unresolved-payment-card">
      <div class="unresolved-payment">
        <div class="unresolved-payment__header">
          <div>
            <vs-checkbox v-model="selectedPayments" :vs-value="index" />
          </div>
          <span v-if="payment.doc_name" class="unresolved-payment__doc-name">
            {{ payment.doc_name }}
          </span>

          <span class="unresolved-payment__date" v-if="payment.date">
            Дата проведения по банку:
            <span class="unresolved-payment__date-value">
              {{ new Date(payment.date) | moment('DD.MM.YYYY') }}
            </span>
          </span>

          <span class="unresolved-payment__sum" v-if="payment.all_amount">
            Сумма:
            <span class="unresolved-payment__sum-number">
              {{ payment.all_amount }}р
            </span>
          </span>


          <div class="unresolved-payment__remove-button" @click="deletePayment">
            <feather-icon icon="Trash2Icon" />
          </div>


        </div>

        <div class="unresolved-payment__body">
          <div class="unresolved-payment__left-block">
            <h1 class="unresolved-payment__user-name">{{ payment.corr_name | userName }}</h1>
            <h4 class="unresolved-payment__inn"
                v-if="payment.corr_inn && payment.corr_inn.length > 1 && Number(payment.corr_inn) > 0">ИНН
              {{ payment.corr_inn }}</h4>
            <div class="unresolved-payment__bills">
              <p v-if="payment.corr_account">Счет: {{ payment.corr_account }}</p>
              <p v-if="payment.corr_bik">Бик: {{ payment.corr_bik }}</p>
            </div>
          </div>

          <div class="unresolved-payment__right-block">
            <p class="unresolved-payment__comment">
              {{ payment.additional_data }}
            </p>
            <div class="unresolved-payment__resolve-container" v-if="$can('rp.invoices', 'write')">
              <div class="unresolved-payment__resolve-house">
                <elsa-v-select
                  :options="houses"
                  label="address"
                  v-model="resolveData.houseId"
                  :reduce="item => item.id"
                  :clearable="false"
                  htmlLabel="Дом"
                  @input="resolveData.errors.houseId = false"
                  :danger="resolveData.errors.houseId"
                  :append-to-body="true"
                />
              </div>

              <div class="unresolved-payment__resolve-apartment">
                <elsa-v-select
                  :options="apartments[resolveData.houseId] || []"
                  :getOptionLabel="(option) => `${option.number} (${option.account_number})`"
                  v-model="resolveData.accountNumber"
                  :reduce="item => item.account_number"
                  :clearable="false"
                  htmlLabel="Помещение"
                  @input="resolveData.errors.accountNumber = false"
                  :disabled="!apartments[resolveData.houseId] || (Array.isArray(apartments[resolveData.houseId]) && !apartments[resolveData.houseId].length)"
                  noData="Помещение не найдено"
                  :placeholder="apartmentPlaceholder"
                  :danger="resolveData.errors.accountNumber"
                  :append-to-body="true"
                />
              </div>

              <div class="unresolved-payment__resolve-month" :class="[{
                'unresolved-payment__resolve-month_error': resolveData.errors.month && resolveData.month === null
              }]">
                <label class="vs-select--label mt-1">Месяц назначения</label>
                <datepicker class="w-full"
                            format="MMMM yyyy"
                            minimum-view="month"
                            maximum-view="year"
                            v-model="resolveData.month"
                />
              </div>

              <div class="unresolved-payment__resolve-buttons">
                <vs-button icon-pack="feather" icon="icon-check" color="success" @click="resolveByData" />
                <vs-button icon-pack="feather" icon="icon-x1" color="danger" @click="resetResolveData" />
              </div>

            </div>
          </div>
        </div>
        <div class="unresolved-payment__footer">

          <p class="possible-options-open-button" :class="[{
            'possible-options-open-button_open': isPossibleOptionsOpen
          }]" v-if="Array.isArray(payment.possible) && payment.possible.length">
            <span class="possible-options-open-button__text" @click="isPossibleOptionsOpen = !isPossibleOptionsOpen">Возможные совпадения</span>
            <feather-icon icon="ChevronDownIcon" class="possible-options-open-button__icon"
                          @click="isPossibleOptionsOpen = !isPossibleOptionsOpen" />
          </p>

        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name:     "UnresolvedPayment",
  props:    {
    zIndex:     {
      default: 1,
    },
    houses:     {
      type:     Array,
      required: true,
    },
    apartments: {},
    payment:    {},
    index:      {},
    selected:   {},
  },
  data:     () => ({
    hoverIndexes:          {
      colIndex: null,
      rowIndex: {
        userId:        null,
        accountNumber: null,
      },
    },
    selectedOptionData:    {
      userId:        null,
      accountNumber: null,
      month:         null,
      indexes:       {
        userId:        null,
        accountNumber: null,
      },
    },
    isPossibleOptionsOpen: false,
    resolveData:           {},
  }),
  computed: {
    selectedPayments: {
      get() {
        return this.selected;
      },
      set( value ) {
        this.$emit("update:selected", value);
      },
    },
    apartmentPlaceholder() {
      const { houseId } = this.resolveData;
      if (houseId === null) return 'Выберите дом';
      const apartments = this.apartments[houseId];
      if (apartments === 0) return 'Загрузка...';
      if (Array.isArray(apartments) && apartments.length) return '';
      return 'Помещений нет';
    },
  },
  methods:  {
    resetResolveData() {
      this.resolveData = {
        houseId:       null,
        accountNumber: null,
        month:         null,
        errors:        {
          houseId:       false,
          accountNumber: false,
          month:         false,
        },
      };
    },
    resolveDataCheckForErrors() {
      let hasErrors = false;

      if (this.resolveData.houseId === null) {
        this.resolveData.errors.houseId = true;
        hasErrors = true;
      }

      if (this.resolveData.houseId !== null && this.resolveData.accountNumber === null) {
        this.resolveData.errors.accountNumber = true;
        hasErrors = true;
      }

      if (this.resolveData.month === null) {
        this.resolveData.errors.month = true;
        hasErrors = true;
      }

      return hasErrors;

    },
    resolveByData() {
      if (this.resolveDataCheckForErrors()) return false;
      let body = {
        buildings_id:          this.resolveData.houseId,
        account_number:        this.resolveData.accountNumber,
        month:                 this.$options.filters.formatDate(this.resolveData.month),
        unresolved_invoice_id: this.payment.id,
      };
      this.$emit('resolve', body);
    },
    deletePayment() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите удалить платеж?',
        acceptText: 'Удалить',
        cancelText: 'Отменить',
        accept:     () => {
          this.$emit('delete');
        },
      });
    },
    selectPossibleOption( apartment ) {
      this.resolveData.houseId = apartment.buildings_id;
      this.$nextTick(() => {
        this.resolveData.accountNumber = apartment.account_number;
      });
    },
  },
  beforeMount() {
    this.resetResolveData();
  },
  mounted() {
  },
  watch:    {
    'resolveData.houseId'() {
      this.resolveData.accountNumber = null;
      this.$emit('changeHouse', this.resolveData.houseId);
    },
  },
  filters:  {
    userName( name ) {
      let text = name;
      if (!text) {
        return 'Не известно';
      }
      const EXCLUDED_WORDS = ['\'', '"', 'ооо', 'зао', 'оао'];
      let textParts = text.split(' ');
      if (textParts.some(r => EXCLUDED_WORDS.includes(r.toLowerCase()))) {
        return text;
      }
      if (textParts.length === 3 || textParts.length === 4) {
        textParts = textParts.map(textPart => {
          let namePart = textPart.trim().toLowerCase();
          if (namePart === 'оглы' || namePart === 'кызы') {
            return namePart;
          }
          return namePart.charAt(0).toUpperCase() + namePart.slice(1);
        });
        text = textParts.join(' ');
      }
      return text;
    },
  },
};
</script>

<style lang="scss">
.unresolved-payment-card {
  /*z-index: 10;*/

  .vx-card__body {
    padding: 0 !important;
  }
}

.unresolved-payment-possible-options-card {
  order: 2;
  margin-top: -.5rem;
  padding-top: .5rem;
}


.unresolved-payment-container {
  display: flex;
  flex-direction: column;

  &_open {
    .unresolved-payment-card {
      border-radius: .5rem .5rem 0 0;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .05);
    }
  }
}

.unresolved-payment {
  padding-bottom: 15px;

  &__header {
    padding: 15px 40px 15px 15px;
    position: relative;
    display: flex;
    align-items: center;
  }

  &__remove-button {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;

    &:hover {
      color: rgba(var(--vs-danger), 1);
    }

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }

  }

  &__doc-name {
    padding-left: .5rem;
  }

  &__date {
    padding-left: 2.5rem;

    @media screen and (max-width: 968px) {
      display: block;
      padding-left: 0;
    }

    &-value {
      font-weight: 600;
      font-size: 1.1rem;
    }
  }

  &__sum {
    padding-left: 2.5rem;

    &-number {
      font-weight: 600;
      font-size: 1.1rem;
    }

    @media screen and (max-width: 968px) {
      display: block;
      padding-left: 0;
    }
  }

  &__body {
    padding: 0 15px;
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 968px) {
      display: block;
    }
  }

  &__left-block {
    align-self: center;
    flex: 1;
    max-width: 500px;
    margin-bottom: 10px;
  }

  &__right-block {
    flex: 1;
    margin-bottom: 10px;
  }

  &__user-name {
    margin: 10px 0;
    padding-right: 5px;
  }

  &__inn {
    margin: 10px 0;
  }

  &__bills {
    display: flex;

    & > p {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }

  }

  &__resolve-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
    flex-wrap: wrap;
    max-width: 800px;
  }

  &__resolve {
    &-house {
      margin-right: .5rem;
      flex: 2;
      min-width: 220px;

      &.input-select-validate-danger {
        .vs-select--label {
          color: rgba(var(--vs-danger), 1);
        }
      }

      .span-text-validation-danger {
        display: none;
      }
    }

    &-apartment {
      margin-right: .5rem;
      flex: 1;
      min-width: 160px;

      &.input-select-validate-danger {
        .vs-select--label {
          color: rgba(var(--vs-danger), 1);
        }
      }

      .span-text-validation-danger {
        display: none;
      }
    }

    &-month {
      margin-right: .5rem;
      width: 130px;

      &_error {
        input {
          border-color: rgba(var(--vs-danger), 1);
        }

        & > label {
          color: rgba(var(--vs-danger), 1);
        }
      }
    }

    &-buttons {
      padding-top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;

      & > * {
        margin-right: .5rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.slide-enter-active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 500px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.possible-options-open-button {
  padding-top: 15px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  &__text {
    font-size: .7rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
    cursor: pointer;
    user-select: none;
  }

  &_open {
    .possible-options-open-button__icon {
      transform: rotate(180deg);
    }
  }

  &__icon {
    color: #000;
    cursor: pointer;
    user-select: none;
    transition: all .3s ease-in;

    svg {
      width: 1rem;
      height: 1rem;
    }
  }


}


.possible-options-table {
  &-wrapper {
    max-width: 1300px;
    margin: 0 auto;
    overflow: auto;
  }

  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  margin-top: 10px;

  &__caption {
    text-transform: uppercase;
    text-align: left;
    margin-bottom: 10px;
    color: #000;
    font-weight: 500;
  }

  &__cell {
    text-align: left;
    font-size: 1rem;
    font-weight: 400;
    /*padding: 0;*/
    border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;
    padding: 10px 5px;

    &:first-child {
      border-left: 1px solid #e2e2e2;
    }

    &:last-child {
      border-right: 1px solid #e2e2e2 !important;
    }

    &_hover, &_active {
      background: rgba(var(--vs-info), .2);
    }

    &_pointer {
      &:hover {
        cursor: pointer;
      }
    }

    &_no-border-left {
      border-left: none !important;
    }

    &_no-border-top {
      border-top: none !important;
    }

    &_no-border {
      border: none !important;
    }

    &_th {
      background: #f9f9f9;
      text-align: center;
      text-transform: uppercase;
      font-weight: 500;
      color: #000;
      font-size: 0.8rem;
    }

  }


}

.possible-option {

  &__user-info {
    text-align: center;

    h5 {
      margin-bottom: 10px;
    }
  }

  &__apartment-info {
    display: flex;
    align-items: center;

    &-address {
      max-width: 500px;
    }

    &-icon {
      margin-right: 5px;

      svg {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
  }

  &__charge-info {
    font-size: .9rem;
    text-align: center;
    white-space: nowrap;
  }

  &__resolve {
    margin-top: -10px;
  }

}

</style>
